import {useQuery} from '@tanstack/react-query';

import {GetListOutput, GetListParams, QueryOptionsForList} from '@shared/api';
import {getPools} from '../api';
import {QUERY__POOLS} from '../queryKeys';
import {Pool} from '../types';

type PoolKind = 'user' | 'topic';
export const useGetPools = <SelectedData = GetListOutput<Pool>>(
  kind: PoolKind,
  id: string,
  params: GetListParams,
  options?: QueryOptionsForList<Pool, SelectedData>,
) =>
  useQuery({
    queryKey: [QUERY__POOLS, kind, id, params],
    queryFn: () => getPools(kind, id, params),
    ...options,
  });
